<template>
  <span>{{ timeRemaining }}</span>
</template>
<script setup lang="ts">
const props = defineProps<{
  // iso date string
  date: string;
}>();

const timeRemaining = computed(() => {
  const endDate = new Date(props.date);
  const now = new Date();

  // Check for invalid date
  if (isNaN(endDate.getTime())) {
    return 'Invalid date';
  }

  const diffTime = Math.max(0, endDate.getTime() - now.getTime()); // Ensure no negative values
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  const diffHours = Math.ceil(diffTime / (1000 * 60 * 60));

  return diffDays > 1
    ? `${diffDays} days remaining`
    : `${diffHours} hours remaining`;
});
</script>
